import { defineStore } from 'pinia'
import { localeStore } from './locale'

export interface PlansCredits {
  id: number
  value: string
  name: string
  creditLivesAssinantes: string
  creditLivesNaoAssinantes: string
  creditVideosAssinantes: string
  creditVideosNaoAssinantes: string
  discount_value: string
  discount?: string
}
export const planCreditStore = defineStore('planscredits', {
  state: () => ({
    plansCredits: [] as Array<PlansCredits>,
    languagePlansCredits: '' as string
  }),
  actions: {
    async setPlanCredits(payload: Array<PlansCredits>) {
      this.plansCredits = payload
      this.setLanguagePlansCredits()
    },
    async setLanguagePlansCredits() {
      const store = localeStore()
      this.languagePlansCredits = store.locale
    }
  },
  persist: {
    enabled: true,
    strategies: [
      {
        key: 'planscredits',
        storage: sessionStorage
      }
    ]
  }
})
